<template>
    <div class="cp-reqs">
        <div data-name="card-title">
            <p>Campaigns' Updates</p>
            <Icon id="campaign-updates-hint" class="cursor-pointer" v-b-tooltip.right title="See update dates scheduled by you and your partner campaigns." icon="hint-icon"/>
        </div>
        <div>
            <Card 
                :data="updates" 
                :columns="columns"
                :totalCount = 'totalCount'
                :loading = "loading"
                :set-expanded-data = "setPartnersUpdates"
            />
        </div>
    </div>
</template>

<script>
import Icon from '../../components/Theme/Icon'
import Card from './components/Card'
import { useUpdates, useFilters, useRouter} from '../../core/hooks'

import {dashboardUtils} from '../../core/utils'
import { watch, ref } from '@vue/composition-api'


export default {
    name: 'CpReqs',
    components: {
        Icon,
        Card
    },
    setup(){

        const {route} = useRouter();
        
        const columns = ref([])
        
        const {
            updates,
            loading,
            totalCount,
            setPartnersUpdates
        } = useUpdates()

        watch(route, (newRoute, oldRoute) => {
            if(!oldRoute || newRoute.query.type !== oldRoute.query.type){
                columns.value = newRoute.query.type === 'unscheduled' ? dashboardUtils.UNSCHEDULED_UPDATES_TABLES_COLUMNS : dashboardUtils.SCHEDULED_UPDATES_TABLE_COLUMNS
            }
        }, {immediate: true})

        return {
            updates,
            loading,
            totalCount,
            columns,
            setPartnersUpdates
        }
    }
}
</script>

<style scoped lang="scss">
div.cp-reqs {

}
</style>
